import React from "react";
import "./toggle.scss";

interface Props {
  isOn: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Toggle = ({ isOn, onClick=()=>{} }: Props) => {
  return (
    <div className={`commontoggle_toggle_switch ${isOn ? "on" : "off"}`} onClick={onClick}>
      <div className="commontoggle_switch_thumb">
        {isOn && (
          <svg className="commontoggle_tick_icon" viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </div>
    </div>
  );
};

export default Toggle;
